const RootPath = window.g.baseUrl
const apis = {
  // 公共api
  login: RootPath + 'plugin/user/authority/default/login',
  logout: RootPath + 'plugin/user/authority/default/logout',
  scan:RootPath + 'plugin/user/authority/default/Code2SessionForScan',
  uploadImage: RootPath + 'plugin/generic/upload/uploadImage',
  uploadFiles: RootPath + 'plugin/generic/upload/uploadFiles',
  delFiles: RootPath + 'plugin/generic/default/delFiles'
}

export default apis
